<template>
  <div>
    <div v-if="tipoBiometria == 'cadastro'">
      <div>
        <img
          class="img"
          src="../../../assets/maoEspelhada.png"
          draggable
          usemap="#image-map"
        />
      </div>

      <map name="image-map">
        <div class="poly1">
          <div
            class="polegar-direito"
            @click="
              selecionarDedo({ label: 'Polegar Direito', value: 'RightThumb' })
            "
          ></div>
          <div
            class="polegar-esquerdo"
            @click="
              selecionarDedo({ label: 'Polegar Esquerdo', value: 'LeftThumb' })
            "
          ></div>
        </div>
        <div class="poly2">
          <div
            class="indicador-direito"
            @click="
              selecionarDedo({
                label: 'Indicador Direito',
                value: 'RightIndex',
              })
            "
          ></div>
          <div
            class="indicador-esquerdo"
            @click="
              selecionarDedo({
                label: 'Indicador Esquerdo',
                value: 'LeftIndex',
              })
            "
          ></div>
        </div>
        <div class="poly3">
          <div
            class="medio-direito"
            @click="
              selecionarDedo({ label: 'Médio Direito', value: 'RightMiddle' })
            "
          ></div>
          <div
            class="medio-esquerdo"
            @click="
              selecionarDedo({ label: 'Médio Esquerdo', value: 'LeftMiddle' })
            "
          ></div>
        </div>
        <div class="poly4">
          <div
            class="anelar-direito"
            @click="
              selecionarDedo({ label: 'Anelar Direito', value: 'RightRing' })
            "
          ></div>
          <div
            class="anelar-esquerdo"
            @click="
              selecionarDedo({ label: 'Anelar Esquerdo', value: 'LeftRing' })
            "
          ></div>
        </div>
        <div class="poly5">
          <div
            class="minimo-esquerdo"
            @click="
              selecionarDedo({ label: 'Mínimo Esquerdo', value: 'LeftPinky' })
            "
          ></div>
          <div
            class="minimo-direito"
            @click="
              selecionarDedo({ label: 'Mínimo Direito', value: 'RightPinky' })
            "
          ></div>
        </div>
      </map>
    </div>
    <div v-if="tipoBiometria == 'verificacao'">
      <div>
        <img
          class="img-verificacao"
          src="../../../assets/maoEspelhada.png"
          draggable
          usemap="#image-map-verificado"
        />
      </div>

      <map name="image-map-verificado">
        <div class="poly1-verificacao">
          <div class="polegar-direito-verificacao"></div>
          <div class="polegar-esquerdo-verificacao"></div>
        </div>
        <div class="poly2-verificacao">
          <div class="indicador-direito-verificacao"></div>
          <div class="indicador-esquerdo-verificacao"></div>
        </div>
        <div class="poly3-verificacao">
          <div class="medio-direito-verificacao"></div>
          <div class="medio-esquerdo-verificacao"></div>
        </div>
        <div class="poly4-verificacao">
          <div class="anelar-direito-verificacao"></div>
          <div class="anelar-esquerdo-verificacao"></div>
        </div>
        <div class="poly5-verificacao">
          <div class="minimo-esquerdo-verificacao"></div>
          <div class="minimo-direito-verificacao"></div>
        </div>
      </map>
    </div>
  </div>
</template>

<script>
import { watch, onMounted } from "vue";
export default {
  emit: ["dedo"],
  props: ["limparDados", "dedosSelecionados", "tipoBiometria"],
  setup(props, { emit }) {
    const removerDedo = () => {
      if (props.tipoBiometria == "cadastro") {
        document
          .querySelector(".polegar-direito")
          .classList.remove("selecionado");
        document
          .querySelector(".polegar-esquerdo")
          .classList.remove("selecionado");
        document
          .querySelector(".indicador-direito")
          .classList.remove("selecionado");
        document
          .querySelector(".indicador-esquerdo")
          .classList.remove("selecionado");
        document
          .querySelector(".medio-direito")
          .classList.remove("selecionado");
        document
          .querySelector(".medio-esquerdo")
          .classList.remove("selecionado");
        document
          .querySelector(".anelar-direito")
          .classList.remove("selecionado");
        document
          .querySelector(".anelar-esquerdo")
          .classList.remove("selecionado");
        document
          .querySelector(".minimo-direito")
          .classList.remove("selecionado");
        document
          .querySelector(".minimo-esquerdo")
          .classList.remove("selecionado");
        document
          .querySelector(".polegar-direito")
          .classList.remove("selecionado");
        document
          .querySelector(".polegar-esquerdo")
          .classList.remove("selecionado");
        document
          .querySelector(".indicador-direito")
          .classList.remove("selecionado");
        document
          .querySelector(".indicador-esquerdo")
          .classList.remove("selecionado");
        document
          .querySelector(".medio-direito")
          .classList.remove("selecionado");
        document
          .querySelector(".medio-esquerdo")
          .classList.remove("selecionado");
        document
          .querySelector(".anelar-direito")
          .classList.remove("selecionado");
        document
          .querySelector(".anelar-esquerdo")
          .classList.remove("selecionado");
        document
          .querySelector(".minimo-direito")
          .classList.remove("selecionado");
        document
          .querySelector(".minimo-esquerdo")
          .classList.remove("selecionado");
        document
          .querySelector(".polegar-direito")
          .classList.remove("cadastrado");
        document
          .querySelector(".polegar-esquerdo")
          .classList.remove("cadastrado");
        document
          .querySelector(".indicador-direito")
          .classList.remove("cadastrado");
        document
          .querySelector(".indicador-esquerdo")
          .classList.remove("cadastrado");
        document.querySelector(".medio-direito").classList.remove("cadastrado");
        document
          .querySelector(".medio-esquerdo")
          .classList.remove("cadastrado");
        document
          .querySelector(".anelar-direito")
          .classList.remove("cadastrado");
        document
          .querySelector(".anelar-esquerdo")
          .classList.remove("cadastrado");
        document
          .querySelector(".minimo-direito")
          .classList.remove("cadastrado");
        document
          .querySelector(".minimo-esquerdo")
          .classList.remove("cadastrado");
        document
          .querySelector(".polegar-direito")
          .classList.remove("cadastrado");
        document
          .querySelector(".polegar-esquerdo")
          .classList.remove("cadastrado");
        document
          .querySelector(".indicador-direito")
          .classList.remove("cadastrado");
        document
          .querySelector(".indicador-esquerdo")
          .classList.remove("cadastrado");
        document.querySelector(".medio-direito").classList.remove("cadastrado");
        document
          .querySelector(".medio-esquerdo")
          .classList.remove("cadastrado");
        document
          .querySelector(".anelar-direito")
          .classList.remove("cadastrado");
        document
          .querySelector(".anelar-esquerdo")
          .classList.remove("cadastrado");
        document
          .querySelector(".minimo-direito")
          .classList.remove("cadastrado");
        document
          .querySelector(".minimo-esquerdo")
          .classList.remove("cadastrado");
      }
      if (props.tipoBiometria == "verificacao") {
        document
          .querySelector(".polegar-direito-verificacao")
          .classList.remove("cadastrado");
        document
          .querySelector(".polegar-esquerdo-verificacao")
          .classList.remove("cadastrado");
        document
          .querySelector(".indicador-direito-verificacao")
          .classList.remove("cadastrado");
        document
          .querySelector(".indicador-esquerdo-verificacao")
          .classList.remove("cadastrado");
        document
          .querySelector(".medio-direito-verificacao")
          .classList.remove("cadastrado");
        document
          .querySelector(".medio-esquerdo-verificacao")
          .classList.remove("cadastrado");
        document
          .querySelector(".anelar-direito-verificacao")
          .classList.remove("cadastrado");
        document
          .querySelector(".anelar-esquerdo-verificacao")
          .classList.remove("cadastrado");
        document
          .querySelector(".minimo-direito-verificacao")
          .classList.remove("cadastrado");
        document
          .querySelector(".minimo-esquerdo-verificacao")
          .classList.remove("cadastrado");
      }
    };

    const selecionarDedo = (p) => {
      emit("dedo", p);
      switch (p.label) {
        case "Polegar Direito":
          document
            .querySelector(".polegar-direito")
            .classList.add("selecionado");
          document
            .querySelector(".polegar-esquerdo")
            .classList.remove("selecionado");
          document
            .querySelector(".indicador-direito")
            .classList.remove("selecionado");
          document
            .querySelector(".indicador-esquerdo")
            .classList.remove("selecionado");
          document
            .querySelector(".medio-direito")
            .classList.remove("selecionado");
          document
            .querySelector(".medio-esquerdo")
            .classList.remove("selecionado");
          document
            .querySelector(".anelar-direito")
            .classList.remove("selecionado");
          document
            .querySelector(".anelar-esquerdo")
            .classList.remove("selecionado");
          document
            .querySelector(".minimo-direito")
            .classList.remove("selecionado");
          document
            .querySelector(".minimo-esquerdo")
            .classList.remove("selecionado");
          break;
        case "Polegar Esquerdo":
          document
            .querySelector(".polegar-esquerdo")
            .classList.add("selecionado");
          document
            .querySelector(".polegar-direito")
            .classList.remove("selecionado");
          document
            .querySelector(".indicador-direito")
            .classList.remove("selecionado");
          document
            .querySelector(".indicador-esquerdo")
            .classList.remove("selecionado");
          document
            .querySelector(".medio-direito")
            .classList.remove("selecionado");
          document
            .querySelector(".medio-esquerdo")
            .classList.remove("selecionado");
          document
            .querySelector(".anelar-direito")
            .classList.remove("selecionado");
          document
            .querySelector(".anelar-esquerdo")
            .classList.remove("selecionado");
          document
            .querySelector(".minimo-direito")
            .classList.remove("selecionado");
          document
            .querySelector(".minimo-esquerdo")
            .classList.remove("selecionado");
          break;
        case "Indicador Direito":
          document
            .querySelector(".indicador-direito")
            .classList.add("selecionado");
          document
            .querySelector(".indicador-esquerdo")
            .classList.remove("selecionado");
          document
            .querySelector(".polegar-esquerdo")
            .classList.remove("selecionado");
          document
            .querySelector(".polegar-direito")
            .classList.remove("selecionado");
          document
            .querySelector(".medio-direito")
            .classList.remove("selecionado");
          document
            .querySelector(".medio-esquerdo")
            .classList.remove("selecionado");
          document
            .querySelector(".anelar-direito")
            .classList.remove("selecionado");
          document
            .querySelector(".anelar-esquerdo")
            .classList.remove("selecionado");
          document
            .querySelector(".minimo-direito")
            .classList.remove("selecionado");
          document
            .querySelector(".minimo-esquerdo")
            .classList.remove("selecionado");
          break;
        case "Indicador Esquerdo":
          document
            .querySelector(".indicador-esquerdo")
            .classList.add("selecionado");
          document
            .querySelector(".indicador-direito")
            .classList.remove("selecionado");
          document
            .querySelector(".polegar-esquerdo")
            .classList.remove("selecionado");
          document
            .querySelector(".polegar-direito")
            .classList.remove("selecionado");
          document
            .querySelector(".medio-direito")
            .classList.remove("selecionado");
          document
            .querySelector(".medio-esquerdo")
            .classList.remove("selecionado");
          document
            .querySelector(".anelar-direito")
            .classList.remove("selecionado");
          document
            .querySelector(".anelar-esquerdo")
            .classList.remove("selecionado");
          document
            .querySelector(".minimo-direito")
            .classList.remove("selecionado");
          document
            .querySelector(".minimo-esquerdo")
            .classList.remove("selecionado");
          break;
        case "Médio Direito":
          document.querySelector(".medio-direito").classList.add("selecionado");
          document
            .querySelector(".medio-esquerdo")
            .classList.remove("selecionado");
          document
            .querySelector(".indicador-esquerdo")
            .classList.remove("selecionado");
          document
            .querySelector(".indicador-direito")
            .classList.remove("selecionado");
          document
            .querySelector(".polegar-esquerdo")
            .classList.remove("selecionado");
          document
            .querySelector(".polegar-direito")
            .classList.remove("selecionado");
          document
            .querySelector(".anelar-direito")
            .classList.remove("selecionado");
          document
            .querySelector(".anelar-esquerdo")
            .classList.remove("selecionado");
          document
            .querySelector(".minimo-direito")
            .classList.remove("selecionado");
          document
            .querySelector(".minimo-esquerdo")
            .classList.remove("selecionado");
          break;
        case "Médio Esquerdo":
          document
            .querySelector(".medio-esquerdo")
            .classList.add("selecionado");
          document
            .querySelector(".medio-direito")
            .classList.remove("selecionado");
          document
            .querySelector(".indicador-esquerdo")
            .classList.remove("selecionado");
          document
            .querySelector(".indicador-direito")
            .classList.remove("selecionado");
          document
            .querySelector(".polegar-esquerdo")
            .classList.remove("selecionado");
          document
            .querySelector(".polegar-direito")
            .classList.remove("selecionado");
          document
            .querySelector(".anelar-direito")
            .classList.remove("selecionado");
          document
            .querySelector(".anelar-esquerdo")
            .classList.remove("selecionado");
          document
            .querySelector(".minimo-direito")
            .classList.remove("selecionado");
          document
            .querySelector(".minimo-esquerdo")
            .classList.remove("selecionado");
          break;
        case "Anelar Direito":
          document
            .querySelector(".anelar-direito")
            .classList.add("selecionado");
          document
            .querySelector(".anelar-esquerdo")
            .classList.remove("selecionado");
          document
            .querySelector(".medio-esquerdo")
            .classList.remove("selecionado");
          document
            .querySelector(".medio-direito")
            .classList.remove("selecionado");
          document
            .querySelector(".indicador-esquerdo")
            .classList.remove("selecionado");
          document
            .querySelector(".indicador-direito")
            .classList.remove("selecionado");
          document
            .querySelector(".polegar-esquerdo")
            .classList.remove("selecionado");
          document
            .querySelector(".polegar-direito")
            .classList.remove("selecionado");
          document
            .querySelector(".minimo-direito")
            .classList.remove("selecionado");
          document
            .querySelector(".minimo-esquerdo")
            .classList.remove("selecionado");
          break;
        case "Anelar Esquerdo":
          document
            .querySelector(".anelar-esquerdo")
            .classList.add("selecionado");
          document
            .querySelector(".anelar-direito")
            .classList.remove("selecionado");
          document
            .querySelector(".medio-esquerdo")
            .classList.remove("selecionado");
          document
            .querySelector(".medio-direito")
            .classList.remove("selecionado");
          document
            .querySelector(".indicador-esquerdo")
            .classList.remove("selecionado");
          document
            .querySelector(".indicador-direito")
            .classList.remove("selecionado");
          document
            .querySelector(".polegar-esquerdo")
            .classList.remove("selecionado");
          document
            .querySelector(".polegar-direito")
            .classList.remove("selecionado");
          document
            .querySelector(".minimo-direito")
            .classList.remove("selecionado");
          document
            .querySelector(".minimo-esquerdo")
            .classList.remove("selecionado");
          break;
        case "Mínimo Direito":
          document
            .querySelector(".minimo-direito")
            .classList.add("selecionado");
          document
            .querySelector(".minimo-esquerdo")
            .classList.remove("selecionado");
          document
            .querySelector(".anelar-esquerdo")
            .classList.remove("selecionado");
          document
            .querySelector(".anelar-direito")
            .classList.remove("selecionado");
          document
            .querySelector(".medio-esquerdo")
            .classList.remove("selecionado");
          document
            .querySelector(".medio-direito")
            .classList.remove("selecionado");
          document
            .querySelector(".indicador-esquerdo")
            .classList.remove("selecionado");
          document
            .querySelector(".indicador-direito")
            .classList.remove("selecionado");
          document
            .querySelector(".polegar-esquerdo")
            .classList.remove("selecionado");
          document
            .querySelector(".polegar-direito")
            .classList.remove("selecionado");
          break;
        case "Mínimo Esquerdo":
          document
            .querySelector(".minimo-esquerdo")
            .classList.add("selecionado");
          document
            .querySelector(".minimo-direito")
            .classList.remove("selecionado");
          document
            .querySelector(".anelar-esquerdo")
            .classList.remove("selecionado");
          document
            .querySelector(".anelar-direito")
            .classList.remove("selecionado");
          document
            .querySelector(".medio-esquerdo")
            .classList.remove("selecionado");
          document
            .querySelector(".medio-direito")
            .classList.remove("selecionado");
          document
            .querySelector(".indicador-esquerdo")
            .classList.remove("selecionado");
          document
            .querySelector(".indicador-direito")
            .classList.remove("selecionado");
          document
            .querySelector(".polegar-esquerdo")
            .classList.remove("selecionado");
          document
            .querySelector(".polegar-direito")
            .classList.remove("selecionado");
          break;

        default:
          break;
      }
    };

    const selecionarDedosCadastrados = (dedo) => {
      if (props.tipoBiometria == "cadastro") {
        switch (dedo) {
          case 1:
            document
              .querySelector(".polegar-direito")
              .classList.add("cadastrado");
            break;
          case 6:
            document
              .querySelector(".polegar-esquerdo")
              .classList.add("cadastrado");
            break;
          case 2:
            document
              .querySelector(".indicador-direito")
              .classList.add("cadastrado");
            break;
          case 7:
            document
              .querySelector(".indicador-esquerdo")
              .classList.add("cadastrado");
            break;
          case 3:
            document
              .querySelector(".medio-direito")
              .classList.add("cadastrado");
            break;
          case 8:
            document
              .querySelector(".medio-esquerdo")
              .classList.add("cadastrado");
            break;
          case 4:
            document
              .querySelector(".anelar-direito")
              .classList.add("cadastrado");
            break;
          case 9:
            document
              .querySelector(".anelar-esquerdo")
              .classList.add("cadastrado");
            break;
          case 5:
            document
              .querySelector(".minimo-direito")
              .classList.add("cadastrado");
            break;
          case 10:
            document
              .querySelector(".minimo-esquerdo")
              .classList.add("cadastrado");
            break;
        }
      }
      if (props.tipoBiometria == "verificacao") {
        switch (dedo) {
          case 1:
            document
              .querySelector(".polegar-direito-verificacao")
              .classList.add("cadastrado");
            break;
          case 6:
            document
              .querySelector(".polegar-esquerdo-verificacao")
              .classList.add("cadastrado");
            break;
          case 2:
            document
              .querySelector(".indicador-direito-verificacao")
              .classList.add("cadastrado");
            break;
          case 7:
            document
              .querySelector(".indicador-esquerdo-verificacao")
              .classList.add("cadastrado");
            break;
          case 3:
            document
              .querySelector(".medio-direito-verificacao")
              .classList.add("cadastrado");
            break;
          case 8:
            document
              .querySelector(".medio-esquerdo-verificacao")
              .classList.add("cadastrado");
            break;
          case 4:
            document
              .querySelector(".anelar-direito-verificacao")
              .classList.add("cadastrado");
            break;
          case 9:
            document
              .querySelector(".anelar-esquerdo-verificacao")
              .classList.add("cadastrado");
            break;
          case 5:
            document
              .querySelector(".minimo-direito-verificacao")
              .classList.add("cadastrado");
            break;
          case 10:
            document
              .querySelector(".minimo-esquerdo-verificacao")
              .classList.add("cadastrado");
            break;
        }
      }
    };

    const receberDedosSelecionados = () => {
      removerDedo();
      if (props.dedosSelecionados == "") {
        return;
      }
      props.dedosSelecionados.forEach((dedo) => {
        selecionarDedosCadastrados(dedo);
      });
    };

    watch(
      () => props.dedosSelecionados,
      () => {
        receberDedosSelecionados();
      }
    );
    watch(
      () => props.limparDados,
      () => {
        removerDedo();
      }
    );

    onMounted(() => {
      receberDedosSelecionados();
    });

    return {
      removerDedo,
      selecionarDedo,
      selecionarDedosCadastrados,
    };
  },
};
</script>

<style scoped>
.poly1 {
  position: relative;
}
.polegar-direito {
  position: absolute;
  top: -167px;
  left: 203px;
  width: 30px;
  height: 30px;
  border-radius: 100px;
  cursor: pointer;
}
.polegar-esquerdo {
  position: absolute;
  top: -167px;
  left: 168px;
  width: 30px;
  height: 30px;
  border-radius: 100px;
  cursor: pointer;
}
.poly2 {
  position: relative;
}
.indicador-direito {
  position: absolute;
  top: -290px;
  left: 255px;
  width: 30px;
  height: 30px;
  border-radius: 100px;
  cursor: pointer;
}
.indicador-esquerdo {
  position: absolute;
  top: -290px;
  left: 116px;
  width: 30px;
  height: 30px;
  border-radius: 100px;
  cursor: pointer;
}
.poly3 {
  position: relative;
}
.medio-direito {
  position: absolute;
  top: -310px;
  left: 301px;
  width: 30px;
  height: 30px;
  border-radius: 100px;
  cursor: pointer;
}
.medio-esquerdo {
  position: absolute;
  top: -310px;
  left: 69px;
  width: 30px;
  height: 30px;
  border-radius: 100px;
  cursor: pointer;
}
.poly4 {
  position: relative;
}
.anelar-direito {
  position: absolute;
  top: -288px;
  left: 343px;
  width: 30px;
  height: 30px;
  border-radius: 100px;
  cursor: pointer;
}
.anelar-esquerdo {
  position: absolute;
  top: -288px;
  left: 28px;
  width: 30px;
  height: 30px;
  border-radius: 100px;
  cursor: pointer;
}
.poly5 {
  position: relative;
}
.minimo-esquerdo {
  position: absolute;
  top: -243px;
  left: -5px;
  width: 30px;
  height: 30px;
  border-radius: 100px;
  cursor: pointer;
}
.minimo-direito {
  position: absolute;
  top: -243px;
  left: 377px;
  width: 30px;
  height: 30px;
  border-radius: 100px;
  cursor: pointer;
}
.poly1-verificacao {
  position: relative;
}
.polegar-direito-verificacao {
  position: absolute;
  top: -86px;
  left: 126px;
  width: 15px;
  height: 15px;
  border-radius: 100px;
}
.polegar-esquerdo-verificacao {
  position: absolute;
  top: -86px;
  left: 109px;
  width: 15px;
  height: 15px;
  border-radius: 100px;
}
.poly2-verificacao {
  position: relative;
}
.indicador-direito-verificacao {
  position: absolute;
  top: -148px;
  left: 161px;
  width: 15px;
  height: 15px;
  border-radius: 100px;
}
.indicador-esquerdo-verificacao {
  position: absolute;
  top: -148px;
  left: 75px;
  width: 15px;
  height: 15px;
  border-radius: 100px;
}
.poly3-verificacao {
  position: relative;
}
.medio-direito-verificacao {
  position: absolute;
  top: -157px;
  left: 190px;
  width: 15px;
  height: 15px;
  border-radius: 100px;
}
.medio-esquerdo-verificacao {
  position: absolute;
  top: -157px;
  left: 47px;
  width: 15px;
  height: 15px;
  border-radius: 100px;
}
.poly4-verificacao {
  position: relative;
}
.anelar-direito-verificacao {
  position: absolute;
  top: -147px;
  left: 216px;
  width: 15px;
  height: 15px;
  border-radius: 100px;
}
.anelar-esquerdo-verificacao {
  position: absolute;
  top: -147px;
  left: 20px;
  width: 15px;
  height: 15px;
  border-radius: 100px;
}
.poly5-verificacao {
  position: relative;
}
.minimo-esquerdo-verificacao {
  position: absolute;
  top: -125px;
  left: -2px;
  width: 15px;
  height: 15px;
  border-radius: 100px;
}
.minimo-direito-verificacao {
  position: absolute;
  top: -124px;
  left: 238px;
  width: 15px;
  height: 15px;
  border-radius: 100px;
}
.polegar-direito:hover {
  background: yellow;
  opacity: 0.7;
}
.polegar-esquerdo:hover {
  background: yellow;
  opacity: 0.7;
}
.indicador-direito:hover {
  background: yellow;
  opacity: 0.7;
}
.indicador-esquerdo:hover {
  background: yellow;
  opacity: 0.7;
}
.medio-direito:hover {
  background: yellow;
  opacity: 0.7;
}
.medio-esquerdo:hover {
  background: yellow;
  opacity: 0.7;
}
.anelar-direito:hover {
  background: yellow;
  opacity: 0.7;
}
.anelar-esquerdo:hover {
  background: yellow;
  opacity: 0.7;
}
.minimo-direito:hover {
  background: yellow;
  opacity: 0.7;
}
.minimo-esquerdo:hover {
  background: yellow;
  opacity: 0.7;
}
.selecionado {
  background: yellow;
  opacity: 0.7;
  z-index: 10;
}
.cadastrado {
  background: green;
  opacity: 0.7;
  z-index: 1;
}
.img {
  height: 300px;
  width: 400px;
}
.img-verificacao {
  height: 150px;
  width: 250px;
}
#image {
  height: 300px;
  width: 400px;
}
</style>
